import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-layout" }
const _hoisted_2 = { class: "account-select" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "account" }, "Conta:", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "app-layout__content" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify--end"
}
const _hoisted_7 = { class: "app-layout__page" }
const _hoisted_8 = { class: "layout fluid gutter--xl" }

import { useStore } from 'vuex';
import { computed, onBeforeUnmount, onMounted, reactive, ref } from 'vue';
import { onBeforeRouteUpdate } from 'vue-router';
import Sidebar from '@/components/sidebar/Sidebar.vue';
import NavBar from '@/components/navbar/NavBar.vue';
import { UserService } from '@/codes/services/UserService';
import {VUEX_ACTIONS} from '@/codes/util/constants';
import { AccountService } from '@/codes/services/AccountService';
import { AuthService } from '@/codes/services/AuthService';
import { Loading } from '@/codes/util/swalUtil';
import Swal from 'sweetalert2';
import {Account, SortOrderEnum, User} from '@/codes/gen/types';
import { ReactiveData } from "@/codes/types/MDOTypes";
 

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const mobileBreakPointPX = 640;
const tabletBreakPointPX = 768;

const sidebarWidth = ref('16rem');
const sidebarMinimizedWidth = ref();

const isMobile = ref(false);
const isTablet = ref(false);
const isSidebarMinimized = computed(() => store.state.isSidebarMinimized)
const checkIsTablet = () => window.innerWidth <= tabletBreakPointPX
const checkIsMobile = () => window.innerWidth <= mobileBreakPointPX

const showSelectAccount = ref(false);
const user = reactive<ReactiveData<User | undefined> >({data: undefined});
const accounts = reactive<ReactiveData<Account[] | undefined>>({ data: [] as Account[] });
const selectedAccount = reactive<ReactiveData<Account>>({ data: {} as Account });

const onResize = () => {
  store.commit('updateSidebarCollapsedState', checkIsTablet())

  isMobile.value = checkIsMobile()
  isTablet.value = checkIsTablet()
  sidebarMinimizedWidth.value = isMobile.value ? 0 : '4rem'
  sidebarWidth.value = isTablet.value ? '100%' : '16rem'
}

const setShowSelectAccountByRole = () => {
  // if(!user.data || !user.data.roles.includes(RoleEnum.Webmaster)){
  //   showSelectAccount.value = false;
  // }else{
  //   showSelectAccount.value = true;
  // }
}

const getUserInfo = async () => {
  const service = new UserService();
  const userInfo = await service.getUserInfo();

  user.data = userInfo as User;
  
  setShowSelectAccountByRole()

  store.dispatch(VUEX_ACTIONS.setUserInfo, userInfo);
}

const loadAccounts = async () => {
  const accountService = new AccountService();
  const result = await accountService.getAll({sort: {  name: SortOrderEnum.Asc }});
  accounts.data = result?.edges;
}

onMounted(() => {
  window.addEventListener('resize', onResize);
  getUserInfo();

  store.subscribeAction({
    after: (action) => {
      switch (action.type) {
        case VUEX_ACTIONS.showSelectAccount:
          loadAccounts();
          showSelectAccount.value = true;
          break;
        case VUEX_ACTIONS.hideSelectAccount:
          showSelectAccount.value = false;
          break;
        case VUEX_ACTIONS.updateAuthToken:
          getUserInfo();
          window.location.reload();
          break;
      }
    }
  });
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})

onBeforeRouteUpdate(() => {
  if (checkIsTablet()) {
    // Collapse sidebar after route change for Mobile
    store.commit('updateSidebarCollapsedState', true)
  }
})

async function changeAccount() {
  Loading.fire("Alterando a conta");
  if (selectedAccount.data) {
    const authService = new AuthService();
    const loginResult = await authService.changeAccount(selectedAccount.data);
    store.dispatch(VUEX_ACTIONS.updateAuthToken, loginResult?.accessToken);
  }
  Swal.close();
}

onResize()

const isFullScreenSidebar = computed(() => isTablet.value && !isSidebarMinimized.value)

const onCloseSidebarButtonClick = () => {
  store.commit('updateSidebarCollapsedState', true)
}


return (_ctx: any,_cache: any) => {
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_va_modal, {
      modelValue: showSelectAccount.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (showSelectAccount.value = $event)),
      title: "Selecione a conta",
      onOk: changeAccount
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(selectedAccount).data = $event)),
            name: "account",
            onOk: changeAccount
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accounts).data, (op) => {
              return (_openBlock(), _createElementBlock("option", {
                key: op.id,
                value: op.id
              }, _toDisplayString(op.name), 9, _hoisted_4))
            }), 128))
          ], 544), [
            [_vModelSelect, _unref(selectedAccount).data]
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(NavBar),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass(["app-layout__sidebar-wrapper", { minimized: _unref(isSidebarMinimized) }])
      }, [
        (_unref(isFullScreenSidebar))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_va_button, {
                class: "px-4 py-4",
                icon: "close",
                flat: "",
                color: "dark",
                onClick: onCloseSidebarButtonClick
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(Sidebar, {
          width: sidebarWidth.value,
          minimized: _unref(isSidebarMinimized),
          "minimized-width": sidebarMinimizedWidth.value
        }, null, 8, ["width", "minimized", "minimized-width"])
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ]))
}
}

})